<template>
	<sf-modal-layout class="qms-xxl" :title="getMessage_('QWCC001357')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<popup-search :scrId="scrId" ref="popSearch" @initComp="initComp" @loadAll="loadAll"></popup-search>
				</sf-card>
			</div>
			<div class="sf-col">
				<sf-card class="border-0 bg-transparent h-100">
					<template v-if="isLoaded">
						<action-buttons :scrId="scrId" @deleteFin="() => close('delete')" @refresh="refresh"></action-buttons>
						<form-apcn ref="apcnView" :scrId="scrId" class="mb-2"></form-apcn>
						<form-info ref="infoView" :scrId="scrId" class="mb-2"></form-info>
						<form-altr ref="altrView" :scrId="scrId" class="mb-2"></form-altr>
						<form-vrf :scrId="scrId"></form-vrf>
					</template>
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/Eo4mApcn/store/helpers';
import ActionButtons from './PopupContent/ActionButtons.vue';
import PopupSearch from './PopupContent/PopupSearch.vue';
import FormApcn from './PopupContent/FormApcn.vue';
import FormInfo from './PopupContent/FormInfo.vue';
import FormAltr from './PopupContent/FormAltr.vue';
import FormVrf from './PopupContent/FormVrf.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			show: false,
			isLoaded: false
		};
	},
	mounted() {
		this.setState_({ key: 'isSaved', value: false });
	},
	components: { ActionButtons, PopupSearch, FormApcn, FormInfo, FormAltr, FormVrf },
	methods: {
		...rootMethods,
		...serviceMethods,
		async open(param) {
			this.$sf_toggleLoading(true);
			this.isLoaded = false;
			this.show = true;
			this.setPopupInit_();
			this.setState_({ key: 'isSaved', value: false });
			try {
				if (!!param) {
					const { partNo, altrNo } = param;
					this.setPopupSearchParams_({ key: 'partNo', value: param.partNo });
					this.setPopupSearchParams_({ key: 'altrNo', value: param.altrNo });
					this.setDetailForm_({ key: 'partNo', value: partNo });
					this.setDetailForm_({ key: 'altrNo', value: altrNo });
					await this.getOne_({ partNo, altrNo });
				} else {
					this.setPopupSearchParams_({ key: 'partNo', value: '' });
					this.setPopupSearchParams_({ key: 'altrNo', value: '' });
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			} finally {
				this.$sf_toggleLoading(false);
				this.setState_({ key: 'isSaved', value: false });
				this.isLoaded = true;
			}
		},
		close() {
			this.$emit('Refresh');
			this.setPopupInit_();
			this.show = false;
			this.isLoaded = false;
		},
		async refresh() {
			try {
				this.isLoaded = false;
				const { partNo, altrNo } = this.detailForm;
				this.setPopupInit_();
				this.initComp();
				await this.getOne_({ partNo, altrNo });
				this.setPopupSearchParams_({ key: 'partNo', value: partNo });
				this.setPopupSearchParams_({ key: 'altrNo', value: altrNo });
			} catch (error) {
			} finally {
				this.isLoaded = true;
			}
		},
		initComp() {
			//별도의 컴포넌트가 있는 항목들의 개별 초기화
			this.$refs.altrView.initImgAll(); //이미지 초기화
			this.$refs.apcnView.setupEmail(); //이메일 부분 초기화
		},
		loadAll() {
			this.initComp();
			this.$refs.infoView.initCombo();
			this.$refs.altrView.loadImg(); //이미지 재로딩 (mounted 이후에 blob 주소 가져오기)
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>
